export interface ResolveOrderInProgressLocationParams {
  locations?: SDict<POSLocation> | SDict<POSLocationShort>;
  orderInProgress?: Sale;
}

/**
 * ## resolveOrderInProgressLocation()
 *
 * Resolves the physical store location for an order in progress using the
 * `storeId` returned by the order status API (`/api/v1/profile/orders` for
 * members, `/api/v1/sale/order` for guests).
 *
 * The `storeId` from the API is the source of truth — it reflects the store
 * the sale was actually placed against, which may differ from the location the
 * user had selected in the ordering flow at display time.
 *
 * Kept as a pure util (not inline in the selector) so it can be unit tested
 * without Redux mocks.
 */
export const resolveOrderInProgressLocation = ({
  locations,
  orderInProgress,
}: ResolveOrderInProgressLocationParams) => {
  if (!orderInProgress || !locations) return;

  const { storeId } = orderInProgress;

  if (storeId === undefined) return;

  const location = locations[storeId];

  return location;
};
